import * as types from '../../actions/ActionTypes';

export const initialState = {
  commonSettings: {
    base: '.',
    courseId: '',
    lang: '',
    title: '',
    logo: '',
    background: '',
    theme: '',
    order: '',
    completeIcon: '',
    comments: '',
    favorites: '',
    screenCapture: '',
    instructions: '',
    saveStats: '',
  },
  contents: [],
  modules: [],
  glossary: {},
  selected: {
    topic: -1,
    act: -1,
    content: 1,
    behavior: '',
  },
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case types.FILL_COMMON_DATA:
      return {
        ...state,
        commonSettings: { ...action.data },
      };
    case types.FILL_GLOSSARY:
      return {
        ...state,
        glossary: action.glossary,
      };
    case types.FILL_SELECTED:
      return {
        ...state,
        selected: action.selected,
      };
    case types.FILL_MODULES:
      return {
        ...state,
        modules: action.modules,
      };
    case types.SET_TOPIC:
      return {
        ...state,
        selected: {
          ...state.selected,
          topic: action.topic,
        },
      };
    case types.SET_ACT:
      return {
        ...state,
        selected: {
          ...state.selected,
          act: action.act,
        },
      };
    case types.SET_SELECTED_CONTENT:
      return {
        ...state,
        selected: {
          ...state.selected,
          content: action.content,
        },
      };
    case types.UPDATE_CONTENT:
      return {
        ...state,
        contents: action.contents,
      };
    default:
      return state;
  }
}
